<!-- src/components/SummaryChart.vue -->
<template>
  <Pie :data="chartData" :options="chartOptions" />
</template>

<script setup>
import { computed } from 'vue';
import { Pie } from 'vue-chartjs';

const props = defineProps({
  summary: {
    type: Object,
    required: true,
  }
});

const chartData = computed(() => ({
  labels: ['Aset (Tabungan)', 'Liabilitas (Pinjaman)'],
  datasets: [
    {
      backgroundColor: ['#42b983', '#dc3545'],
      data: [
        parseFloat(props.summary.total_assets),
        parseFloat(props.summary.total_liabilities)
      ]
    }
  ]
}));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false
};
</script>